import _ from "lodash";

/**
 * Language codes should be the shortest available ISO 639 code
 * per https://tools.ietf.org/html/bcp47#section-2.1
 * See https://iso639-3.sil.org/code_tables/639/data
 * to lookup codes
 */
export enum LanguageCode {
  English = "en",
  AmericanSignLanguage = "asl",
  Arabic = "ar",
  Bengali = "bn",
  Cantonese = "yue",
  French = "fr",
  German = "de",
  Gujarati = "gu",
  Hindi = "hi",
  Igbo = "ig",
  Indonesian = "id",
  Italian = "it",
  JamaicanPatois = "jam",
  Japanese = "ja",
  Korean = "ko",
  Mandarin = "cmn",
  Portuguese = "pt",
  Russian = "ru",
  Spanish = "es",
  Swahili = "sw",
  Urdu = "ur",
  Vietnamese = "vi",
  Yoruba = "yo",
}
export const DEFAULT_OUTSCHOOL_LANGUAGE: LanguageCode = LanguageCode.English;

const languages: { [K in LanguageCode]: string } = {
  en: "English",
  asl: "American Sign Language",
  ar: "Arabic",
  bn: "Bengali",
  yue: "Cantonese",
  fr: "French",
  de: "German",
  gu: "Gujarati",
  hi: "Hindi",
  ig: "Igbo",
  id: "Indonesian",
  it: "Italian",
  jam: "Jamaican Patois",
  ja: "Japanese",
  ko: "Korean",
  cmn: "Mandarin Chinese",
  pt: "Portuguese",
  ru: "Russian",
  es: "Spanish",
  sw: "Swahili",
  ur: "Urdu",
  vi: "Vietnamese",
  yo: "Yoruba",
};

// Subset of our language choices that are used to filter language_of_instruction
export const LANGUAGE_FILTER_CODES: LanguageCode[] = [LanguageCode.Spanish];
export const languageFilters = LANGUAGE_FILTER_CODES.map(code => ({
  label: `Taught in ${codeToText(code)}`,
  value: code,
}));

export const LANGUAGE_TAUGHT_CODES: LanguageCode[] = [
  LanguageCode.English,
  LanguageCode.Spanish,
];

export function codeToText(code: LanguageCode) {
  return languages[code];
}

export function textToCode(text: string) {
  const codeTextPair = _.toPairs(languages).find(
    ([, languageAsText]) => text === languageAsText
  );
  return codeTextPair ? codeTextPair[0] : text;
}
